<template>
    <div v-show="active">
        <click-outside :handler="close" id="marketo-picker" class="fp-popup" style="width: 75%">
            <div class="widgettitle acclaro-vue-content">
                <div class="controls">
                    <span class="acclaro-icon ai-close" @click="close()"></span>
                </div>
                Choose File(s) from Marketo
                <span v-show="loading_files !== 0 || this.loading">(Loading, please wait...)</span>
            </div>

            <div class="clearfix fp-columns">
                <div style="">

                    <div class="marketo-menu clearfix">
                        <ul>
                            <li :class="{ active: mode === 'browse' }"><a href="javascript:;" @click="mode = 'browse'">Browse</a></li>
                            <li :class="{ active: mode === 'search' }"><a href="javascript:;" @click="mode = 'search'">Search</a></li>
                        </ul>
                        <ul class="right secondary" v-show="mode === 'browse'">
                            <li><a href="javascript:;" @click="expandAll()">Expand all</a></li>
                            <li><a href="javascript:;" @click="collapseAll()">Collapse all</a></li>
                        </ul>
                    </div>

                    <div class="bordered">
                        <form class="marketo-search" v-show="mode === 'search'" action="javascript:;" @submit.prevent="searchFor">
                            <input type="text" v-model="search" placeholder="Type something and press Enter..." />
                        </form>

                        <span class="fp-loading" v-show="loading">
                            Please wait while reading Marketo assets for:<p><span class="marketo-workspace" v-if="loading_folder_name !== ''"><b>{{ loading_folder_name}}</b></span></p>
                        </span>

                        <div class="structure">
                            <div v-show="noSearchResults()" style="padding:0 10px 10px">
                                No search results...
                            </div>
                            <div v-for="(child, index) in folders">
                                <marketo-child :tree="child.children" :parent_key="child.parent_key" :id_key="child.key" :parent_id="child.id" :idType="child.idType" :folderType="child.folderType" :parent_path="''" :folder_id="child.id" :name="child.name" :type="child.type" v-if="child.type === 'folder'"></marketo-child>

                                <div class="marketo-item marketo-file" v-if="child.type !== 'folder'">
                                    {{ child.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="right">
                    <div class="marketo-menu clearfix">
                        <span v-if="modal_type === 'source'">Source Files</span>
                        <span v-if="modal_type === 'reference'">Reference Files</span>
                    </div>
                    <div class="bordered">
                        <p v-show="selected.length === 0" style="padding:10px">
                            Selected files go here
                        </p>

                        <div v-show="selected.length !== 0">
                            <div v-for="(file, index) in selected" class="marketo-file-selected">
                                <ul>
                                    <li :class="{
                                        'marketo-title': true,
                                        'marketo-email' :  isAssetEmail(file),
                                        'marketo-email-template' : isAssetEmailTemplate(file),
                                        'marketo-landing-page' : isAssetLandingPage(file),
                                        'marketo-landing-page-template' : isAssetLandingPageTemplate(file),
                                        'marketo-snippet' : isAssetSnippet(file),
                                        }" > {{ file.name }} <span class="market-file-id">({{ file.id }})</span>
                                        <span class="delete" @click="removeAsset(index)">&nbsp;</span>
                                    </li>
                                    <li class="folder">{{ file.folder }}</li>
                                    <li class="url"><a v-bind:href="file.url" target="_blank">{{ file.url }}</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fp-buttons">
                <ul v-show="loading_files !== 0 || this.loading">
                    <li>Loading, please wait...</li>
                </ul>
                <ul v-show="loading_files === 0 && ! this.loading">
                    <li v-show="selected.length !== 0">Estimated Word Count: {{ getWordCount() }}</li>
                    <li><button type="button" @click="clear" :class="{ sfupload: true, disabled: selected.length === 0 }" :disabled="selected.length === 0">Clear</button></li>
                    <li><button type="button" @click="uploadSelectedFiles" :class="{ sfupload: true, disabled: selected.length === 0 }" :disabled="selected.length === 0">Upload</button></li>
                </ul>
            </div>
        </click-outside>
        <div class="fp-mask" :style="{ display: active ? 'block' : 'none' }"></div>
    </div>
</template>

<script>
    import {EventBus} from "../../event-bus";
    import ClickOutside from 'onclick-outside'

    import AssetMixin from '../../assetMixins.js';
    import {mapGetters, mapState} from "vuex";

    let base64 = require('base-64')

    export default {

        mixins: [AssetMixin],

        components: {
            'click-outside': ClickOutside
        },
      computed: {
        ...mapState({
          uploadFileType: state => state.CreateOrderStore.orderDetails.uploadFileType,
          features: state => state.store.features,
        }),
        ...mapGetters('FeatureFlagStore', {
          'getFeature': 'getFeatureStatusByName'
        }),
      },

        data() {
            return {
                total_children_assets: 0,
                search_results: {
                    matched: 0,
                    not_matched: 0
                },
                loading_files: 0,
                mode: 'browse',
                modal_type: 'source',
                active: false,
                folders: [],
                files: {},
                children: {},
                selected_folder: null,
                loading: true,
                breadcrumb: [
                    {
                        id: 0,
                        name: 'Root'
                    }
                ],
                selected: [],
                search: null,
                loading_timer: null,
                loading_folder_name: null,
                order_id: 0
            }
        },

        methods: {

            noSearchResults() {
                return this.search !== '' && this.search !== null && (this.total_children_assets === (this.search_results.matched + this.search_results.not_matched)) && this.search_results.matched === 0
            },

            getWordCount() {
                var count = 0;

                for(var item in this.files)
                {
                    count += this.files[item].word_count
                }

                return isNaN(count) ? 'Unknown' : count
            },

            clear() {
                this.selected = []
                this.files = {}
                this.loading_files = 0
            },

            uploadSelectedFiles () {
                if (this.selected.length === 0) {
                    alert('You need to select at least one file to upload');
                    return;
                }

                axiosCache.post('/connectors/marketo/upload', {
                    order_id: this.order_id,
                    file_type: this.modal_type,
                    json_data: JSON.stringify(this.files)
                })
                    .then(response => {
                        this.active = false;
                        this.clear();
                    })
                    .catch(error => {
                        console.log(error);
                        alert('Whoops! Something went wrong on our end! Please, try again later.');
                    })
                    .finally(() => {
                      if(featureOn){
                        EventBus.$emit('file-uploaded');
                      } else {
                        refreshUploadedFileList(orderId);
                      }
                    });

            },

            removeAsset(index) {
                if(Object.keys(this.files).indexOf(this.selected[index].module + '_' + this.selected[index].id) !== -1){
                    delete this.files[this.selected[index].module + '_' + this.selected[index].id]
                }

                this.selected.splice(index, 1)
            },

            searchFor() {
                this.search_results = {
                    matched: 0,
                    not_matched: 0
                }

                EventBus.$emit('search', { query: this.search })
            },

            moveFromBreadcrumb(index) {
                if(index === 0) {
                    this.breadcrumb.length = 1
                    this.selected_folder = null
                    return
                }

                var destination = this.breadcrumb[index]

                this.selected_folder = destination.id

                this.loadFolder(destination)

                this.breadcrumb.length = index + 1
            },

            getCurrentPath() {
                var path = []

                this.breadcrumb.forEach(item => {
                    path.push(item.name)
                })

                return path.join('/')
            },

            getFolderStructure(key, name, workspace, ) {
                if (typeof key === 'undefined') return false

                if (typeof name !== 'undefined') this.loading_folder_name = name

                if (typeof workspace === "undefined") workspace = '';

                this.folders = null

                clearTimeout(this.loading_timer)

                this.loading = true

                axiosCache.get('/connectors/marketo/tree?key=' + key + '&workspace=' + workspace)
                    .then(response => {
                        this.loading_folder_name = ''

                        this.folders = response.data

                        this.loading_timer = setTimeout(() => {
                            this.loading = false;

                            setTimeout(() => {
                                EventBus.$emit('expand_all')
                            }, 1000)

                        }, 300)
                    })
                    .catch(error => {})
            },

            getWorkspaceStructure() {
                clearTimeout(this.loading_timer)
                this.loading = true

                axiosCache.get('/connectors/marketo/tree')
                    .then(response => {
                        this.folders = response.data

                        this.loading_timer = setTimeout(() => {
                            this.loading = false;

                            setTimeout(() => {
                                EventBus.$emit('expand_all')
                            }, 1000)

                        }, 300)
                    })
                    .catch(error => {})
            },

            selectAsset(item) {
                item.path = this.getCurrentPath()
                this.selected.push(item)
            },

            loadFolder(parent) {
                if(parent.type === 'asset') {
                    this.selectAsset(parent)
                    return
                }

                /*
                this.breadcrumb.push(parent)
                this.selected_folder = parent.id
                this.loading = true

                axiosCache.get('/connectors/marketo/folder?parent_id=' + parent.id)
                    .then(response => {
                        this.children[parent.id] = response.data
                        //this.loading = false

                        this.loading_timer = setTimeout(() => {
                            this.loading = false;
                        }, 4000);
                    })
                    .catch(error => {})

                */
            },

            listActiveItems() {
                if(this.selected_folder === null)
                    return this.folders

                return this.children[this.selected_folder]
            },

            collapseAll() {
                EventBus.$emit('collapse_all')
            },

            expandAll() {
                EventBus.$emit('expand_all')
            },

            close() {
                if( ! this.active)
                    return

                if(this.selected.length !== 0)
                {
                    if( ! confirm('You have ' + this.selected.length + ' selected file(s), are you sure you want to close this dialog?'))
                    {
                        this.active = true
                        return
                    }
                }

                this.active = false
            },

            isAssetSelected(item)
            {
                var found = -1

                this.selected.forEach((asset, index) => {
                    if(asset.id === item.id && item.module === asset.module)
                        found = index
                })

                return found
            },

            fetchFile(file) {
                this.loading_files++;

                axiosCache.get('/connectors/marketo/file?payload=' + JSON.stringify({
                    id: file.id,
                    module: file.module
                }))
                    .then(response => {
                        this.loading_files--;
                        this.files[file.module + '_' + file.id] = response.data
                    })
                    .catch(error => {})
            }

        },

        mounted() {
            this.getWorkspaceStructure();

            EventBus.$on('get_workspace_tree', (data) => {

                this.getFolderStructure(data.key, data.name, data.workspace)

            })

            EventBus.$on('show-marketo-picker', (data) => {
                this.active = true
                this.modal_type = data.type

            })

            EventBus.$on('filepicker_file_select', (data) => {
                if(this.isAssetSelected(data.file) !== -1) {
                    popupAlert('You have already selected ' + data.file.name, 'Duplicate File')
                    return
                }

                this.selected.push(data.file)

                EventBus.$emit('update_selected_assets', { files: this.selected })

                this.fetchFile(data.file)
            })

            EventBus.$on('filepicker_file_deselect', (data) => {
                if(this.isAssetSelected(data.file) === -1) {
                    return
                }

                this.removeAsset(this.isAssetSelected(data.file))

                EventBus.$emit('update_selected_assets', { files: this.selected })
            })

            EventBus.$on('children_report', data => {
                this.total_children_assets += data.items
            })

            EventBus.$on('search_results_feedback', data => {
                this.search_results.matched += data.matched
                this.search_results.not_matched += data.not_matched
            })
        }

    }
</script>
